const VARIANTS_ENUMS = {
  DISPLAY_3XL: "display-3xl",
  DISPLAY_XL: "display-xl",
  DISPLAY_LG: "display-lg",
  DISPLAY_MD: "display-md"
};
const TAGS_ENUMS = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};
export {
  TAGS_ENUMS,
  VARIANTS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
